import { createTheme, alpha } from "@mui/material";
import { deepmerge } from "@mui/utils";
import baseThemeOptions from "./baseThemeOptions";

const colorSet = {
  primaryMain: "#00204b",
  secondary: "#0A5EC5",
  defaultTextColor: "#303030",
};

const themeWbsGroup = createTheme(
  deepmerge(baseThemeOptions, {
    palette: {
      primary: {
        main: colorSet.primaryMain,
      },

      secondary: {
        main: colorSet.secondary,
      },

      widgetStyles: {
        minimizedChatBubble: {
          backgroundColor: colorSet.primaryMain,
          iconColor: "#fff",
          hoverColor: colorSet.secondary,
        },

        navbar: {
          backgroundColor: colorSet.primaryMain,
          textColor: "#fff",
          chevronColor: "#fff",
          chevronHoverColor: alpha(colorSet.secondary, 0.2),
        },

        welcomePage: {
          backgroundColor: colorSet.primaryMain,
          textColor: "#fff",
          linkColor: "#fff",
          linkHoverColor: colorSet.secondary,
        },

        dataProtectionPage: {
          backgroundColor: "#fff",
          headlineColor: colorSet.primaryMain,
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.primaryMain,
          linkHoverColor: colorSet.secondary,
        },

        button: {
          primary: {
            backgroundColor: colorSet.primaryMain,
            textColor: "#fff",
            hoverColor: colorSet.secondary,
          },
          secondary: {
            backgroundColor: colorSet.primaryMain,
            textColor: colorSet.defaultTextColor,
            hoverColor: colorSet.secondary,
          },
        },

        userChatBubble: {
          background: alpha(colorSet.primaryMain, 0.8),
          textColor: "#fff",
          linkColor: "#fff",
          linkHoverColor: colorSet.secondary,
        },

        botChatBubble: {
          background: alpha(colorSet.defaultTextColor, 0.1),
          textColor: colorSet.defaultTextColor,
          linkColor: "#003A5D",
          linkHoverColor: "#0071B2",
        },

        chatControls: {
          backgroundColor: "#fff",
          iconColor: "#637286",
          iconHoverColor: colorSet.secondary,
        },
      },
    },
  })
);

export default themeWbsGroup;
